import React from "react";
const SvgPoiBus = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#39434E"
        d="M12 24C5.372 24 0 18.627 0 12S5.372 0 12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12z"
      />
      <path
        fill="#FFF"
        d="M16.524 12.957c0 .15-.124.274-.274.274H7.47a.275.275 0 01-.276-.274v-4.39c0-.15.124-.274.276-.274h8.78c.15 0 .274.124.274.274v4.39zm-.686 3.155a.687.687 0 110-1.373.687.687 0 010 1.373zm-7.957 0a.687.687 0 110-1.373.687.687 0 010 1.373zm1.235-9.74c0-.151.122-.275.274-.275h4.94c.15 0 .273.124.273.276v.547a.274.274 0 01-.274.274H9.39a.273.273 0 01-.274-.274v-.547zm8.78 1.92h-.275V6.92c0-.452-.332-.989-.736-1.19 0 0-1.458-.73-5.025-.73s-5.025.73-5.025.73c-.408.201-.738.738-.738 1.19v1.373h-.274A.825.825 0 005 9.116v.823c0 .453.37.824.823.824h.274v5.623c0 .357.23.662.55.775v.46a1.1 1.1 0 001.097 1.098 1.1 1.1 0 001.097-1.098v-.412h6.036v.412c0 .604.495 1.098 1.097 1.098.604 0 1.099-.494 1.099-1.098v-.46a.827.827 0 00.548-.775v-5.623h.275a.825.825 0 00.822-.824v-.823a.824.824 0 00-.822-.823z"
      />
    </g>
  </svg>
);
export default SvgPoiBus;
